import { Stack, styled } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { ModalProvider, Navbar } from 'src/components';
import { useGlobalQuickActions } from 'src/components/Navbar/use-global-quick-actions';
import { useGlobalShortcuts } from 'src/utils/hooks';

const AppContent = styled(Stack, { name: 'AppContent' })(({ theme }) => ({
  height: '100%',
  overflow: 'auto',
  overscrollBehavior: 'none',
  backgroundColor:
    theme.palette.mode === 'dark'
      ? theme.palette.custom.OV.sys.surfaceDim
      : theme.palette.custom.OV.sys.background,

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
  },
}));

export const RoutesContainer = () => {
  useGlobalQuickActions();
  useGlobalShortcuts();

  return (
    <AppContent>
      <Navbar />
      <Stack
        flex="1 1 auto"
        overflow="auto"
        sx={{ overscrollBehavior: 'none' }}
        data-testid="app-protected-routes"
      >
        <Outlet />
        <ModalProvider />
      </Stack>
    </AppContent>
  );
};
